import { z } from 'zod';
import { SHEET_DESCRIPTION_MAX, SHEET_NAME_MAX } from '../constants/limits.js';
import { SHEET_ICONS } from '../types/sheet.js';
const HexColor = z.string().regex(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i, 'Must be a hex color');
const DisplayMode = z.enum(['embed', 'open_external', 'native']);
export const CreateSheetRequestSchema = z.object({
    name: z.string().min(1).max(SHEET_NAME_MAX),
    description: z.string().max(SHEET_DESCRIPTION_MAX).optional(),
    icon: z.enum(SHEET_ICONS).optional(),
    accentColor: HexColor.optional(),
    embedUrl: z.string().min(1).max(2_000),
    displayMode: DisplayMode.optional(),
});
export const UpdateSheetRequestSchema = z
    .object({
    name: z.string().min(1).max(SHEET_NAME_MAX).optional(),
    description: z.string().max(SHEET_DESCRIPTION_MAX).nullable().optional(),
    icon: z.enum(SHEET_ICONS).nullable().optional(),
    accentColor: HexColor.nullable().optional(),
    embedUrl: z.string().min(1).max(2_000).optional(),
    displayMode: DisplayMode.optional(),
    isActive: z.boolean().optional(),
})
    .refine((data) => Object.keys(data).length > 0, {
    message: 'At least one field must be provided',
});
export const SheetIdParamSchema = z.object({ id: z.string().uuid() });
export const SheetUserParamSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
});
export const GrantSheetBodySchema = z.object({ sheetId: z.string().uuid() });
export const GrantUserBodySchema = z.object({ userId: z.string().uuid() });
//# sourceMappingURL=sheet.schema.js.map